<div class="container-fuild">
  <div class="w-100 overflow-hidden position-relative flex-wrap d-block vh-100">
    <div class="row">
      <div class="col-lg-5">
        <div
          class="d-lg-flex align-items-center justify-content-center d-none flex-wrap vh-100 bg-primary-transparent"
        >
          <div>
            <img src="../../../../assets/img/bg/authentication-bg-03.svg" alt="Img" />
          </div>
        </div>
      </div>
      <div class="col-lg-7 col-md-12 col-sm-12">
        <div class="row justify-content-center align-items-center vh-100 overflow-auto flex-wrap">
          <div class="col-md-7 mx-auto vh-100">
            <!-- <div class="alert alert-danger" *ngIf="errorMessage$ | async">
              {{ errorMessage$ | async }}
            </div>

            <div class="clearfix"></div> -->
            <form [formGroup]="form" (ngSubmit)="authenticate()" class="vh-100">
              <div class="vh-100 d-flex flex-column justify-content-between p-4 pb-0">
                <div class="mx-auto mb-5 text-center">
                  <img src="../../../../assets/img/logo/logo.webp" class="img-fluid" alt="Logo" />
                </div>
                <div class="">
                  <div class="text-center mb-3">
                    <h2 class="mb-2">Sign In</h2>
                    <p class="mb-0">Please enter your details to sign in</p>
                  </div>
                  <div class="mb-3">
                    <label for="email" class="form-label">Email Address</label>
                    <div class="input-group">
                      <input
                        id="email"
                        type="text"
                        value=""
                        formControlName="email"
                        autocomplete="email"
                        class="form-control border-end-0"
                        appStrictEmail
                        appTrimInput
                      />
                      <span class="input-group-text border-start-0">
                        <i class="ti ti-mail"></i>
                      </span>
                    </div>
                    <div *ngIf="form.get('email')?.invalid && form.get('email')?.touched">
                      <span class="text-danger">{{ getErrorMessage('email') }}</span>
                    </div>
                  </div>
                  <div class="mb-3">
                    <label for="password" class="form-label">Password</label>
                    <div class="pass-group">
                      <input
                        id="password"
                        class="pass-input form-control"
                        [type]="isPasswordVisible ? 'text' : 'password'"
                        autocomplete="current-password"
                        formControlName="password"
                        appTrimInput
                      />
                      <span
                        [class]="
                          isPasswordVisible
                            ? 'ti toggle-password ti-eye-off'
                            : 'ti toggle-password ti-eye'
                        "
                        id="toggle-password"
                        (click)="togglePasswordVisibility()"
                        (keydown)="onKeydown($event)"
                        tabindex="1"
                        role="button"
                      ></span>
                    </div>
                    <div *ngIf="form.get('password')?.invalid && form.get('password')?.touched">
                      <span class="text-danger">{{ getErrorMessage('password') }}</span>
                    </div>
                  </div>
                  <div class="d-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center">
                      <div class="form-check form-check-md mb-0 d-none">
                        <input
                          appTrimInput
                          class="form-check-input"
                          id="remember_me"
                          type="checkbox"
                        />
                        <label for="remember_me" class="form-check-label mt-0">Remember Me</label>
                      </div>
                    </div>
                    <div class="text-end">
                      <a [routerLink]="eps.auth.forgotPasswordPath" class="link-danger"
                        >Forgot Password?</a
                      >
                    </div>
                  </div>
                  <div class="mb-3">
                    <button
                      type="submit"
                      class="btn btn-primary w-100"
                      [disabled]="form.invalid || (isLoading$ | async)"
                    >
                      <ng-container *ngIf="isLoading$ | async; else loading">
                        <span
                          class="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Signing...
                      </ng-container>
                      <ng-template #loading> Sign In </ng-template>
                    </button>
                  </div>
                  <!-- <div class="text-center">
                    <h6 class="fw-normal text-dark mb-0">
                      Don’t have an account?
                      <a [routerLink]="eps.auth.registerPath" class="hover-a"> Create Account</a>
                    </h6>
                  </div> -->
                  <div class="login-or d-none">
                    <span class="span-or">Or</span>
                  </div>
                  <div class="mt-2 d-none">
                    <div class="d-flex align-items-center justify-content-center flex-wrap">
                      <div class="text-center me-2 flex-fill">
                        <a
                          href="javascript:void(0);"
                          class="br-10 p-2 btn btn-info d-flex align-items-center justify-content-center"
                        >
                          <img
                            class="img-fluid m-1"
                            src="../../../../assets/img/icons/facebook-logo.svg"
                            alt="Facebook"
                          />
                        </a>
                      </div>
                      <div class="text-center me-2 flex-fill">
                        <a
                          href="javascript:void(0);"
                          class="br-10 p-2 btn btn-outline-light border d-flex align-items-center justify-content-center"
                        >
                          <img
                            class="img-fluid m-1"
                            src="../../../../assets/img/icons/google-logo.svg"
                            alt="Facebook"
                          />
                        </a>
                      </div>
                      <div class="text-center flex-fill">
                        <a
                          href="javascript:void(0);"
                          class="bg-dark br-10 p-2 btn btn-dark d-flex align-items-center justify-content-center"
                        >
                          <img
                            class="img-fluid m-1"
                            src="../../../../assets/img/icons/apple-logo.svg"
                            alt="Apple"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="mt-5 pb-4 text-center">
                  <!-- <p class="mb-0 text-gray-9">Copyright &copy; 2025 - AVR Software Pvt. Ltd.</p> -->
                  <!-- <p class="mb-0  textt-gray-9">{{ copyrightText }}</p> -->
                  <p class="mb-0 textt-gray-9" id="copyright" [innerHTML]="copyrightText"></p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
